import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from 'buefy';
// import 'buefy/dist/buefy.css'
import VuePlyr from 'vue-plyr';
import VueTour from 'vue-tour'
import VueAgile from 'vue-agile'


// require('vue-tour/dist/vue-tour.css');

Vue.use(VueTour);
Vue.use(VuePlyr);
Vue.use(Buefy);
Vue.use(VueAgile);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
